import clsx from "clsx";
import React from "react";

import { SupportedLocales } from "../../../../i18n/config";
import { getCountryLanguageFromLocaleCode } from "../../../../utils/i18n";
import { Icon } from "../../../icon";
import { Tag, TagProps } from "../../../tag";

export interface LocaleSelectorTagProps extends TagProps {
  locale: string | SupportedLocales;
}

export function LocaleSelectorTag({ className, locale, ...rest }: LocaleSelectorTagProps) {
  const { country, language } = getCountryLanguageFromLocaleCode(locale);
  return (
    <Tag
      className={clsx(
        "flex items-center gap-1 !text-base lg:!text-sm cursor-pointer select-none",
        className
      )}
      {...rest}
    >
      <Icon icon="world" className="h-6 lg:h-4 w-6 lg:w-4" />
      {`${country}-${language}`}
    </Tag>
  );
}
